import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    name: "",
}

export const settingsCategoriesFilterSlice = createSlice({
    name: 'settingsCategoriesFilter',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            state = {
                ...state, 
                ...payload.payload
            };
            return state;
        }
    },
})

export const { edit } = settingsCategoriesFilterSlice.actions

export default settingsCategoriesFilterSlice.reducer